function isPromoLineItem(item) {
  const props = item?.properties || {};
  return props._source === 'checkout_upsell' || props._source === 'checkout_free_gift';
}

function blockPromoQuantityEdit(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
}

function lockCartPagePromoQuantities(cart) {
  const cartSection = document.querySelector('.shopify-section--main-cart');
  if (!cartSection || !cart?.items?.length) return;

  cart.items.forEach((item) => {
    if (!isPromoLineItem(item)) return;

    cartSection
      .querySelectorAll(`.quantity-input[data-line-key="${CSS.escape(item.key)}"]`)
      .forEach((input) => {
        input.readOnly = true;
        input.setAttribute('aria-readonly', 'true');
        input.classList.add('quantity-input--promo-locked');
        input.dataset.promoLocked = 'true';

        if (input.dataset.promoLockBound === 'true') return;
        input.dataset.promoLockBound = 'true';
        input.dataset.lockedQuantity = input.value;

        ['keydown', 'input', 'change'].forEach((eventName) => {
          input.addEventListener(eventName, blockPromoQuantityEdit, true);
        });
      });
  });
}

function initCartPagePromoLock() {
  if (!document.querySelector('.shopify-section--main-cart')) return;

  fetch(`${window.Shopify.routes.root}cart.js`)
    .then((response) => response.json())
    .then(lockCartPagePromoQuantities)
    .catch((error) => console.error('Cart Lock Promo Quantity Error:', error));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartPagePromoLock);
} else {
  initCartPagePromoLock();
}

document.documentElement.addEventListener('cart:change', (event) => {
  if (event.detail?.cart) {
    lockCartPagePromoQuantities(event.detail.cart);
  }
});
